//New track GA4 For June-ng

export const DATA_LAYER_TRACKING_EVENTS = {
    LOGIN: 'login',
    LOGOUT: 'logout',
    SIGN_UP: 'sign_up',
    VIEW_ITEM: 'view_item',
    ADD_ITEM: 'add_item',
    REMOVE_ITEM: 'remove_item',
    CLEAR_CART: 'clear_cart',
    CHECKOUT: 'begin_checkout',
    PURCHASE: 'purchase'
}

const PURCHASE_TRACKED_STORAGE_KEY = 'dataLayerTrackedPurchaseIds'

const canUseDataLayer = () => typeof window !== 'undefined'

const getTrackedPurchaseIds = () => {
    if (!canUseDataLayer() || !window.sessionStorage) return []

    try {
        return JSON.parse(window.sessionStorage.getItem(PURCHASE_TRACKED_STORAGE_KEY)) || []
    } catch (error) {
        return []
    }
}

const setTrackedPurchaseId = transactionId => {
    if (!transactionId || !canUseDataLayer() || !window.sessionStorage) return

    const trackedPurchaseIds = getTrackedPurchaseIds()
    if (trackedPurchaseIds.includes(transactionId)) return

    window.sessionStorage.setItem(
        PURCHASE_TRACKED_STORAGE_KEY,
        JSON.stringify([...trackedPurchaseIds, transactionId])
    )
}

const hasTrackedPurchaseId = transactionId => {
    if (!transactionId) return false

    return getTrackedPurchaseIds().includes(transactionId)
}

export const toDataLayerNumber = value => {
    const parsedValue = Number(String(value || 0).replace(/,/g, '').replace(/[^0-9.-]+/g, ''))

    return Number.isNaN(parsedValue) ? 0 : parsedValue
}

const resolveItemName = name => {
    if (!name) return ''
    if (typeof name === 'string') return name
    return name.english || name.native || Object.values(name)[0] || ''
}

export const createDataLayerItem = (item = {}, quantity = 1) => ({
    item_id: item.item_id || item.item_code,
    item_name: resolveItemName(item.item_name),
    flavor: item.flavor,
    price: toDataLayerNumber(item.price),
    quantity: Number(item.quantity || item.qty || quantity),
    pv: item.pv,
    type: item.type
})

export const pushDataLayerEvent = (event, data = {}, options = {}) => {
    if (!event || !canUseDataLayer()) return

    window.dataLayer = window.dataLayer || []

    if (options.resetEcommerce === true) {
        window.dataLayer.push({ ecommerce: null })
    }

    window.dataLayer.push({
        event,
        ...data
    })
}

export const trackLogin = (data = {}) => {
    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.LOGIN, data)
}

export const trackLogout = (data = {}) => {
    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.LOGOUT, data)
}

export const trackSignUp = (data = {}) => {
    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.SIGN_UP, data)
}

export const trackViewItem = (ecommerce = {}) => {
    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.VIEW_ITEM, { ecommerce }, { resetEcommerce: true })
}

export const trackAddItem = (ecommerce = {}) => {
    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.ADD_ITEM, { ecommerce }, { resetEcommerce: true })
}

export const trackRemoveItem = (ecommerce = {}) => {
    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.REMOVE_ITEM, { ecommerce }, { resetEcommerce: true })
}

export const trackClearCart = (ecommerce = {}) => {
    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.CLEAR_CART, { ecommerce }, { resetEcommerce: true })
}

export const trackCheckout = (ecommerce = {}) => {
    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.CHECKOUT, { ecommerce }, { resetEcommerce: true })
}

export const trackPurchase = (ecommerce = {}) => {
    const transactionId = ecommerce.transaction_id
    if (hasTrackedPurchaseId(transactionId)) return

    pushDataLayerEvent(DATA_LAYER_TRACKING_EVENTS.PURCHASE, { ecommerce }, { resetEcommerce: true })
    setTrackedPurchaseId(transactionId)
}

const DataLayerTrackingEvents = {
    createDataLayerItem,
    pushDataLayerEvent,
    trackLogin,
    trackLogout,
    trackSignUp,
    trackViewItem,
    trackAddItem,
    trackRemoveItem,
    trackClearCart,
    trackCheckout,
    trackPurchase
}

export default DataLayerTrackingEvents
